import { roleApi } from "api/role.api";
import { action, makeAutoObservable } from "mobx";
import { makePersistable } from "mobx-persist-store";
import { adminRoutes, AppRoute } from "router";
import { settings } from "settings";
import { userStore } from "store/userStore";
import { Permission } from "types/role";
import { can } from "utils/auth";

class PermissionStore {
  permissions: Permission[] = [];
  accessRoutes: AppRoute[] = [];

  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "PermissionStore",
      properties: ["permissions"],
      storage: localStorage,
    });
  }

  fetchPermissions = async (roleId: number) => {
    const res = await roleApi.findOne(roleId);
    const permissions = res.data.permissions || [];
    this.permissions = permissions;
    if (userStore.info.role) {
      userStore.info.role.permissions = permissions;
    }
  };

  setAccessRoutes = () => {
    if (!settings.checkPermission) return;

    for (const route of this.accessRoutes) {
      route.isAccess = !!route.isPublic || can(route.path || "", "VIEW");
    }
  };
}

const permissionStore = new PermissionStore();

export { permissionStore };
